import { API } from "./APIClient";
import { getCurrentUserId } from "../utils/reduxUser";

class MainPageAPIClass {
    async fetchShiftInfo(cafeId) {
        const userId = getCurrentUserId();
        const response = await API.get(`/mainPage/currentRevenue/${cafeId}?employee_id=${userId}`);

        return {
            goal: response.data.goal,
            current: response.data.current,
        };
    }
}

const MainPageAPI = new MainPageAPIClass();
export default MainPageAPI;
